{
  "de": {
    "survey": {
      "actions": {
        "add": "Neu hinzufügen",
        "addDescription": "Beschreibung hinzufügen",
        "close": "Schließen",
        "create": "Erstellen",
        "createNew": "Neu",
        "delete": "Löschen",
        "deleteCount": "Sie sind dabei, {count} Umfrage zu löschen. Sind Sie sicher? | Sie sind dabei, {count} Umfragen zu löschen. Sind Sie sicher?",
        "deleteMultiple": "Löschen …",
        "delete_cancel": "Abbrechen",
        "delete_surveys": "Umfrage löschen | Umfragen löschen",
        "importTemplate": "Importieren",
        "newSurvey": "Umfrage",
        "publish": "Veröffentlichen",
        "publishCustomer": "Für Kunden veröffentlichen",
        "revokeAccess": "Zugriff entziehen",
        "save": "Speichern",
        "selectAll": "Alle {total} Umfragen auswählen",
        "send": "Senden",
        "sendCustomer": "An Kunde senden",
        "submit": "Absenden",
        "surveys_collapse": "Umfragen einklappen",
        "surveys_expand": "Umfragen ausklappen",
        "unSelectAll": "Auswahl aufheben.",
        "unpublish": "Veröffentlichung aufheben"
      },
      "attributes": {
        "description": "Interner Titel",
        "title": "Ihre Frage"
      },
      "labels": {
        "NPSOverview": "NPS-Übersicht",
        "NPSQuestion": "Wie wahrscheinlich ist es, dass Sie {name} einem Freund oder Kollegen empfehlen?",
        "addQuestion": "Frage",
        "answerRequired": "Antwort (erforderlich)",
        "answer_later": "Später beantworten",
        "answeredAt": "Beantwortet am",
        "average_score": "Durchschnittliche Bewertung",
        "clientTeam": "Das {name}-Team",
        "comments": "Kommentare oder Vorschläge? (optional)",
        "completedTime": "Beantwortet",
        "customer": "Kunde",
        "customer_status": "Status",
        "detractors": "Kritiker",
        "dissatisfied": "Unzufrieden",
        "extremelyLikely": "Äußerst wahrscheinlich",
        "lets_go": "Los geht's",
        "list": "Liste",
        "mostRecentAnswers": "Neueste Antworten",
        "neither_satisfied_nor_dissatisfied": "Weder zufrieden noch unzufrieden",
        "neutrals": "Neutrale",
        "noAnswers": "Noch keine Antworten",
        "noSurveyFeedback": "Keine Kommentare oder Vorschläge",
        "noSurveysYet": "Noch keine Umfragen. Erstellen Sie Ihre erste Umfrage, um loszulegen.",
        "noUnitsClick": "Noch keine Einheiten, hier klicken, um sie hinzuzufügen",
        "no_opinion": "Keine Meinung",
        "notAtAllLikely": "Überhaupt nicht wahrscheinlich",
        "nps": "NPS",
        "numberAnswered": "{answered} von {total} Antworten",
        "obligatory": "Umfrage für Kunden verpflichtend machen",
        "pendingSurveys": " Wir benötigen Ihr Feedback",
        "promoters": "Promotoren",
        "publishNow?": "Jetzt veröffentlichen?",
        "published": "Veröffentlicht",
        "publishedCount": "Diese Umfrage für den Kunden veröffentlichen | {count} Umfragen für Kunden veröffentlichen",
        "question": "Frage",
        "question_number": "Frage {current_number} von {total_questions}",
        "questions": "Fragen",
        "respondents": "Keine Teilnehmer | 1 Teilnehmer | {count} Teilnehmer",
        "response": "Antwort",
        "responseTime": "Antwortzeit",
        "responses": "Antworten",
        "revokeAccessCount": "Zugriff auf diese Umfrage für den Kunden entziehen | Zugriff auf diese Umfrage für {count} Kunden entziehen",
        "satisfied": "Zufrieden",
        "saveExplainer": "Diese Umfrage für Ihre Kunden sichtbar machen? Oder speichern und später veröffentlichen?",
        "scoreBreakdown": "Bewertungsübersicht",
        "selectOneUnit": "Wählen Sie mindestens 1 Umfrage aus",
        "selectUnits": "Einheiten auswählen",
        "selected": "{selected} Umfrage ist ausgewählt. | {selected} Umfragen sind ausgewählt.",
        "sendCount": "Diese Umfrage an den Kunden senden | Umfragen an {count} Kunden senden",
        "sendExplainer": "Ihre Kunden sehen dies auf ihrem Dashboard",
        "sendNow?": "Jetzt senden?",
        "sent": "Gesendet",
        "sentCustomer": "An Kunde gesendet",
        "showSurveysFor": "Umfragen anzeigen für",
        "showingResultsFor": "Ergebnisse werden angezeigt für",
        "step0Title": "Welches Vorlagenprojekt und welche Umfrage möchten Sie verwenden?",
        "step2Subtitle": "Damit Ihre Kunden den Zweck dieser Umfrage kennen",
        "step2Title": "Fügen Sie eine kurze Einleitung hinzu",
        "step3Subtitle": "Wählen Sie Ihr Projekt aus, um alle Einheiten auf einmal einzuschließen.",
        "step3Title": "Für welche Einheiten möchten Sie diese Umfrage erstellen?",
        "survey": "Umfrage",
        "surveyAlreadyAnswered": "Die Umfrage wurde bereits beantwortet. Vielen Dank für Ihr Feedback.",
        "surveyAnswer": "Feedback",
        "surveyNotCompleted": "Die Umfrage ist noch nicht abgeschlossen.",
        "surveys": "Umfragen",
        "surveysCount": "{count} Umfrage | {count} Umfragen",
        "surveys_all_projects": "Umfragen aller Projekte",
        "tabOverview": "Übersicht",
        "tabSurveys": "Umfragen",
        "thankYou": "Vielen Dank für Ihr Feedback!",
        "title": "Frage",
        "titles_must_be_unique": "Es gibt doppelte Fragen. Fragen müssen eindeutig sein!",
        "totalSelected": "Alle {total} Umfragen sind ausgewählt.",
        "unanswered": "Unbeantwortet",
        "unit": "Einheit",
        "unitSelected": "Noch keine Einheit ausgewählt | Eine Einheit ausgewählt | {count} Einheiten ausgewählt",
        "units": "Einheiten",
        "unitsWithoutSurvey": "{count} Einheit ohne Umfrage | {count} Einheiten ohne Umfrage",
        "unpublishedCount": "Veröffentlichung dieser Umfrage aufheben | Veröffentlichung von {count} Umfragen aufheben",
        "very_dissatisfied": "Sehr unzufrieden",
        "very_satisfied": "Sehr zufrieden",
        "visibility": "Sichtbarkeit",
        "yourAnswers": "Ihre Antworten",
        "yourQuestion": "Ihre Frage"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Bitten Sie Ihre Kunden um Feedback",
            "title": "Erstellen Sie Ihre erste Umfrage"
          },
          "none": {
            "subtitle": "Bitten Sie Ihre Kunden um Feedback",
            "title": "Keine Umfragen gefunden"
          }
        }
      },
      "toasts": {
        "bulk_create": "Umfrage erfolgreich erstellt | Umfragen erfolgreich erstellt",
        "bulk_delete": "Umfrage erfolgreich gelöscht | Umfragen erfolgreich gelöscht",
        "bulk_update": "Umfrage erfolgreich aktualisiert | Umfragen erfolgreich aktualisiert",
        "update": "Umfrage erfolgreich aktualisiert"
      },
      "validation": {
        "needName": "Geben Sie eine Frage ein",
        "needQuestion": "Fügen Sie mindestens 1 Frage hinzu",
        "selectUnit": "Wählen Sie mindestens 1 Einheit aus"
      }
    }
  }
}
